import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/hooks/use-mobile";
import { ErrorAlert } from "@/lib/components/error-alert";
import { BackButton, BaseNavigationBar } from "@/lib/components/navigation";
import { PageContent } from "@/lib/components/page-content";
import { SettingsSearchTrigger } from "../../search/components/settings-search-trigger";
import {
  CurrentSalonRoleCard,
  NotificationPreferencesCard,
  ProfileInfoCard,
  ProfileLoading,
} from "./components";
import { useProfile } from "./hooks";

export function ProfileSettingsPage() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { t } = useTranslation("settings");
  const { profile, loading, error } = useProfile();

  return (
    <>
      <BaseNavigationBar
        title={t("sections.profile.title")}
        subtitle={t("sections.profile.description")}
        leadElement={
          isMobile ? <BackButton key="back-button" onBack={() => navigate(-1)} /> : undefined
        }
        trailingElements={[<SettingsSearchTrigger key="search-trigger" />]}
      />

      <PageContent>
        <div className="space-y-6">
          <ErrorAlert error={error as Error | null} />

          {loading && !profile ? (
            <ProfileLoading />
          ) : !error && profile ? (
            <>
              <ProfileInfoCard profile={profile} />
              <CurrentSalonRoleCard />
              <NotificationPreferencesCard />
            </>
          ) : null}
        </div>
      </PageContent>
    </>
  );
}
